import { z } from 'zod';

import { AIMessageChunk, Message } from './agent-chat-types';

/**
 * V2 Agent Chat Stream Event types.
 *
 * These correspond to the backend's AgentChatStreamEvent discriminated union
 * (app/defs/agent_chat.py). The backend streams these as SSE `data:` lines.
 */

export const AgentChatRunStatus = z.enum([
  'pending',
  'running',
  'completed',
  'failed',
  'cancelled',
]);

export type TAgentChatRunStatus = z.infer<typeof AgentChatRunStatus>;

export const AgentChatStreamTokenEvent = z.object({
  type: z.literal('token'),
  token: AIMessageChunk,
});

export const AgentChatStreamMessageEvent = z.object({
  type: z.literal('message'),
  message: Message,
});

export const AgentChatStreamControlEvent = z.object({
  type: z.literal('control'),
  status: AgentChatRunStatus,
});

export const AgentChatStreamEvent = z.discriminatedUnion('type', [
  AgentChatStreamTokenEvent,
  AgentChatStreamMessageEvent,
  AgentChatStreamControlEvent,
]);

export type TAgentChatStreamEvent = z.infer<typeof AgentChatStreamEvent>;
export type TAgentChatStreamTokenEvent = z.infer<
  typeof AgentChatStreamTokenEvent
>;
export type TAgentChatStreamMessageEvent = z.infer<
  typeof AgentChatStreamMessageEvent
>;
export type TAgentChatStreamControlEvent = z.infer<
  typeof AgentChatStreamControlEvent
>;

// Run status response from GET /messages/status/
export const RunStatusResponse = z.object({
  has_active_run: z.boolean(),
  run: z
    .object({
      id: z.string(),
      status: AgentChatRunStatus,
      stream_available: z.boolean().optional(),
    })
    .nullable(),
});

export type TRunStatusResponse = z.infer<typeof RunStatusResponse>;
